
<div *ngIf="acmLoyChannelList && acmLoyChannelList.length > 0; else emptyList">

<table class="detail-tab actiontable">
  <thead>
    <tr>
      <th class="pl-4" colspan="2">{{ 'acm.channel_id' | translate }}</th>
      <th>{{ 'acm.dateStart' | translate }}</th>
      <th>{{ 'acm.dateEnd' | translate }}</th>
      <th style="text-align: center;">{{ 'acm.dateStartAcm' | translate }}</th>
      <th style="text-align: center;">{{ 'acm.dateEndAcm' | translate }}</th>
      <th style="text-align: center;">{{ 'acm.circolaritaEsterna' | translate }}</th>
      <th></th>

    </tr>
  </thead>
  <br>
  <tbody>
    <tr *ngFor="let row of acmLoyChannelList;  let i=index;">
      <td class="pl-4" colspan="2" [ngClass]="checkExpiredAcmChannel(row)">{{ row.channelDescription }}</td>
      <td [ngClass]="checkExpiredAcmChannel(row)">{{ row.date_start }}</td>
      <td [ngClass]="checkExpiredAcmChannel(row)">{{ row.date_end }}</td>
      <td [ngClass]="checkExpiredAcmChannel(row)"style="text-align: center;">{{ row.date_pti_start }}</td>
      <td [ngClass]="checkExpiredAcmChannel(row)"style="text-align: center;">{{ row.date_pti_end }}</td>

        <td>
          <div class="d-flex justify-content-center" style="margin-top:1px">
            <p-inputSwitch [ngModel]="isSwitchChecked(row.flg_ext_circ)" [disabled]="true"></p-inputSwitch>
          </div>
        </td>


      <td>
        <div class="detail-btn-container">
          <div class="d-flex flex-row">
              <button class="btn-details" (click)="toggleMenu(row.id,i)">
                  <i class="pi pi-ellipsis-h margin-fit"></i>
              </button>
              <div class="dropdown-menu" *ngIf="row.menuActivated == true && row.flg_state=='0'">
                  <button class="dropdown-item" (click)="onEditAcmChannel(row)">{{ 'acm.editChannel' | translate }}</button>
                  <button class="dropdown-item" (click)="onDeleteAcmChannel(row)">{{ 'acm.deleteAcmChannel' | translate }}</button>
              </div>
              <div class="dropdown-menu" *ngIf="row.menuActivated == true && row.flg_state=='1'">
                <button class="dropdown-item" (click)="onRecoverAcmChannel(row)">{{ 'acm.recoverChannel' | translate }}</button>

            </div>
          </div>
      </div>
      </td>
    </tr>
  </tbody>
</table>
</div>
<ng-template #emptyList>
  <div class="empty-list-container">
    <span class="empty-list-message">{{ 'acm.emptyListAcm' | translate }}</span>
  </div>
</ng-template>

<div class="detail-btn-container">
  <button (click)="onCreateNewAcmChannel()"  class="new-acm-channel-button">
      <i class="pi pi-plus"></i>{{ 'channel.add_title' | translate }}
  </button>
</div>

<div *ngIf="showPopupCreate">
  <p-dialog header="Aggiungi Canale" [(visible)]="showPopupCreate">
    <app-acm-channel-new-3 [fatherAcmChannel]="fatherAcmChannel"
     [listChannel]="listChannel"
     (refreshPage)="refreshAfterChanges($event)"
     (closeCreationPopup)="onClosePopupCreation()"
     ></app-acm-channel-new-3>
  </p-dialog>
</div>


<div *ngIf="showPopupEdit">
  <p-dialog header="Edit Canale" [(visible)]="showPopupEdit">
    <app-acm-channel-edit-3   (refreshPage)="refreshAfterChanges($event)"
    [acmLoyChannel]="selectedAcmChannel"
    (closeEditPopup)="onClosePopupEdit()"
    [fatherAcmChannel]="fatherAcmChannel"
    [listChannel]="listChannel"></app-acm-channel-edit-3>
  </p-dialog>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/acm-detail-3/acm-detail-3.component.html